/**
 * Certification badge tooltips on product cards.
 * Hover/focus shows tip; tap toggles on touch; Escape / outside click closes.
 * Card grid: flip handled by product-card-cert-flip.js.
 */
(function () {
  'use strict';

  if (window.productCardCertBadge) return;

  const SELECTOR = '.cert-badge';

  function tipEl(badge) {
    return badge.querySelector('.cert-badge__tip');
  }

  function isCardGridBadge(badge) {
    return Boolean(badge.closest('.cert-badges-bar--card'));
  }

  function closeBadge(badge) {
    if (!badge) return;
    badge.classList.remove('is-open');
    badge.setAttribute('aria-expanded', 'false');
    const tip = tipEl(badge);
    if (tip) tip.hidden = true;
  }

  function openBadge(badge) {
    document.querySelectorAll(`${SELECTOR}.is-open`).forEach((other) => {
      if (other !== badge) closeBadge(other);
    });
    badge.classList.add('is-open');
    badge.setAttribute('aria-expanded', 'true');
    const tip = tipEl(badge);
    if (tip) tip.hidden = false;
  }

  function toggleBadge(badge) {
    if (badge.classList.contains('is-open')) closeBadge(badge);
    else openBadge(badge);
  }

  document.addEventListener(
    'click',
    (event) => {
      const badge = event.target.closest(SELECTOR);
      if (badge) {
        if (badge.classList.contains('cert-badge--inactive')) return;
        if (isCardGridBadge(badge)) return;
        event.preventDefault();
        event.stopPropagation();
        toggleBadge(badge);
        return;
      }

      document.querySelectorAll(`${SELECTOR}.is-open`).forEach(closeBadge);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${SELECTOR}.is-open`).forEach(closeBadge);
  });

  window.productCardCertBadge = {
    closeBadge,
    openBadge,
    toggleBadge,
    isCardGridBadge,
  };
})();
